import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import DocumentViewer from "../../../../../../shared/components/redesigned/DocumentViewer";
import { ToolbarPillButton } from "../../../../../../shared/components/redesigned/DocumentViewer/Toolbar";
import { useGetUnitQuery } from "../../../../../../services/management/units/api";
import { useGetMetadataQuery } from "../../../../../../services/supervising/metadata/api";
import { useGetProcessedDataQuery } from "../../../../../../services/supervising/processedData/api";
import { useGetSubmissionsQuery } from "../../../../../../services/supervising/submissions/api";
import useUnitToolbar from "../UnitToolbar";

export default function UnitShow() {
    const { unitId } = useParams();
    const navigate = useNavigate();
    const [currentUrlParams] = useSearchParams();
    const id = Number(unitId);

    const result = useGetUnitQuery(id, { skip: !Number.isFinite(id) });
    const metadata = useGetMetadataQuery(id, { skip: !Number.isFinite(id) });
    const processed = useGetProcessedDataQuery(id, { skip: !Number.isFinite(id) });
    const submissions = useGetSubmissionsQuery(id, { skip: !Number.isFinite(id) });
    const { button: toolbarButton, panel: toolbarPanel } = useUnitToolbar(
        result.data,
        metadata.data,
        processed.currentData,
        processed.isFetching,
        submissions.currentData,
        submissions.isFetching,
    );

    if (!result.data) {
        return null;
    }

    const { documentId, accountId, format } = result.data;

    return (
        <div className="relative flex h-full max-w-full flex-1 bg-surface-2">
            <DocumentViewer
                documentId={documentId}
                accountId={accountId}
                format={format}
                allowDownload
                topLeft={
                    <ToolbarPillButton
                        icon={faXmark}
                        title="close"
                        onClick={() =>
                            navigate({
                                pathname: "/supervising/units",
                                search: currentUrlParams.toString(),
                            })
                        }
                    />
                }
                topRight={toolbarButton}
                rightPanel={toolbarPanel}
            />
        </div>
    );
}
